// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"b92d8123","582":"c82d5308","735":"decc95c9","755":"9ed6f2ea","853":"ec07c405","940":"73cf8603"}[chunkId] + ".chunk.css";
};